import { render } from "./HomePageFooter.vue?vue&type=template&id=4c58c99e"
import script from "./HomePageFooter.vue?vue&type=script&lang=js"
export * from "./HomePageFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__